$(document).ready(function () {
    /*
    $(".js-userdropdown-toggle").on("click", function (e) {
        var $this = $(e.currentTarget);
        var target = $this.attr("data-target");
        //

        if ($(target).is(":visible")) {
            e.stopPropagation();
            $(target).hide();
            $this.removeClass("active");
        } else {
            $(target).show();
            $this.addClass("active");
        }
    });*/


    //toggle between login and lost password
    $(document).on("click", ".js-usermanagement-lostpw-toggle", function () {
        $(".js-usermanagement-login").hide();
        $(".js-usermanagement-lostpw-container").show();
        $(".js-usermanagementlostpw-email").val($(".js-usermanagement-username").val());
        $(".js-usermanagementlostpw-email").focus();
    });
    
    $(".js-usermanagement-toggle").click(function () {
        $(".js-usermanagement-lostpw-container").hide();
        $(".js-usermanagement-login").show();
        $(".js-usermanagement-username").focus();
    });
    

    /*
    $(document).bind("mouseup touchend", function (e) {
        var navigation = $(".js-navigation-mobile");
        var userdropdown = $(".js-userdropdown-container");
        if (!userdropdown.is(e.target) && userdropdown.has(e.target).length === 0) {
            userdropdown.hide();
            $(".js-userdropdown-toggle").removeClass("active");
            //$(".js-mobile-toggle[data-target='#js-mobile-cart']").removeClass("active");
        }
        if ($(".js-header-content").is(":visible")) {
            var search = $(".js-content-large-container");
            if (!search.is(e.target) && search.has(e.target).length === 0) {
                $(".js-content-large").hide();
            }
        }


        //var navigation = $(".js-navigation-mobile");

        //if (!navigation.is(e.target) && navigation.has(e.target).length === 0) {
        //    navigation.hide();
        //    $(".js-navigation-toggle").removeClass("is-active");
        //}
    });*/


    $(".js-cc-product-list").change(function () {
        var value = $(this).val();
        if (value == "createNew") {
            $(".js-cc-product-list-new").slideDown();
        } else {
            $(".js-cc-product-list-new").slideUp();
        }
    });

    $(".js-create-new-list").on("click", function (e) {
        e.preventDefault();
        var selectId = $(this).data("selectid");
        if (document.getElementById("CC_Name_" + selectId).value.length == 0 && document.getElementById("CC_List_" + selectId).value == 'createNew') {
            //eval("alert('@Translate("SmartPage:Product.FavoriteList.CreateNewError", "Vælg en eksisterende liste eller opret en ny.")')");
            document.getElementById("CC_Name_" + selectId).focus();
            return false;
        }
        else {
            document.getElementById('AddListForm' + selectId).submit();
        }
    });

    $(".js-remove-from-list").on("click", function (e) {
        e.preventDefault();
        var selectId = $(this).data("selectid");
        var action = $(this).data("remove-from-list");

        if (document.getElementById("CC_List_" + selectId).value == 'createNew') {
            //eval("alert('@Translate("SmartPage:Product.FavoriteList.DeleteError", "Den valgte liste eksisterer ikke, vælg en anden.")')");
            document.getElementById("CC_Name_" + selectId).focus();
            return false;
        } else {
            document.getElementById('AddListForm' + selectId).action = action;
            document.getElementById('AddListForm' + selectId).submit();
        }
    });



    
    

    $("form[name=UserManagementEditForm]").on("submit", function () {
        if ($("#UserManagement_Form_Email").length) {
            $(this).append($('<input>', {
                type: 'hidden',
                name: "UserManagement_Form_UserName",
                value: $("#UserManagement_Form_Email").val()
            }));
        }
    });


});

function addNewList(select, elementId) {
    if (select.value == 'createNew') {
        document.getElementById("CC_Name_" + elementId).value = "";
        document.getElementById("CC_Name_" + elementId).focus();
    }
}